import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer">
            #Instagram Clone - Vaibhav Bansal
        </div>
    )
}

export default Footer
